import Drawer from "src/shared/components/layout/drawer/Drawer"
import TabMenu from "src/shared/components/navigation/tab-menu/TabMenu"
import { formatTextWithCapitalize } from "src/shared/hooks/formatTextOpcions"
import useComentariosIncidencia from "./hooks/useComentariosIncidencia"
import { incidenciasDetailTabs } from "./IncidenciasDetail.constants"
import { IncidenciasDetailProps, IncidenciasDetailTab } from "./IncidenciasDetail.type"
import ComentariosTab from "./sections/ComentariosTab"
import DetalleTab from "./sections/DetalleTab"
import "./IncidenciasDetail.css"

const emptyValue = "-"

const IncidenciasDetail = ({ isOpen, onClose, data, activeTab, onChangeTab }: IncidenciasDetailProps): JSX.Element => {
    const { comentarios, loading } = useComentariosIncidencia({
        folio: data?.folio_incidencia,
        enabled: isOpen && activeTab === "comentarios",
    })

    return (
        <Drawer placement={"right"} bar={false} visible={isOpen} withCloseButton onClose={onClose} testId="incidencias-detail">
            <div className="inc-detail__head">
                <p className="inc-detail__title">{data?.folio_incidencia ? `Folio ${data.folio_incidencia}` : emptyValue}</p>
                <p className="inc-detail__subtitle">
                    {data?.tipo_incidencia ? formatTextWithCapitalize(data.tipo_incidencia) : emptyValue}
                </p>
            </div>
            <TabMenu
                className="inc-detail__tabs"
                darkMode
                value={activeTab}
                tabList={incidenciasDetailTabs}
                onChange={(value) => onChangeTab(value as IncidenciasDetailTab)}
            />
            <div className="inc-detail__body">
                {activeTab === "detalle" ? (
                    <DetalleTab data={data} />
                ) : (
                    <ComentariosTab comentarios={comentarios} loading={loading} />
                )}
            </div>
        </Drawer>
    )
}

export default IncidenciasDetail
